import type {
  UpdateUserMapSettingsRequest,
  UpdateUserMeasurementSystemRequest,
  UserMapSettingsResponse,
} from '@fleet-bffs/api-contract';
import { bffWebApi, TagTypes } from '~/api';
import { applyMeasurementSystem } from '~/ducks/authentication/apply-measurement-system';

const settingsApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getUserMapSettings: build.query<UserMapSettingsResponse, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/users/settings/map-settings`,
      }),
      providesTags: [TagTypes.UserMapSettings],
    }),
    updateUserMapSettings: build.mutation<UserMapSettingsResponse, UpdateUserMapSettingsRequest>({
      query: (body) => ({
        url: `${process.env.ENDPOINT_BFF}/users/settings/map-settings`,
        method: 'PATCH',
        body,
      }),
      async onQueryStarted(body, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          settingsApi.util.updateQueryData('getUserMapSettings', undefined, (draft) => {
            if (body.userMapTypeId !== undefined) {
              draft.userMapTypeId = body.userMapTypeId;
            }
          })
        );

        try {
          const { data } = await queryFulfilled;
          dispatch(settingsApi.util.upsertQueryData('getUserMapSettings', undefined, data));
        } catch {
          patchResult.undo();
        }
      },
    }),
    updateUserMeasurementSystem: build.mutation<void, UpdateUserMeasurementSystemRequest>({
      query: (body) => ({
        url: `${process.env.ENDPOINT_BFF}/users/settings/measurement-system`,
        method: 'PATCH',
        body,
      }),
      async onQueryStarted(body, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(applyMeasurementSystem(body.measurementSystem));
        } catch {}
      },
    }),
    updateVisitedMower: build.mutation<void, string>({
      query: (iprId) => ({
        url: `${process.env.ENDPOINT_BFF}/users/settings/visited-mowers/${iprId}`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetUserMapSettingsQuery,
  useUpdateUserMapSettingsMutation,
  useUpdateVisitedMowerMutation,
  useUpdateUserMeasurementSystemMutation,
} = settingsApi;

export default settingsApi;
